import { render, staticRenderFns } from "./EditarDespacho.vue?vue&type=template&id=9148b964&scoped=true&"
import script from "./EditarDespacho.vue?vue&type=script&lang=ts&"
export * from "./EditarDespacho.vue?vue&type=script&lang=ts&"
import style0 from "./EditarDespacho.vue?vue&type=style&index=0&id=9148b964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9148b964",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9148b964', component.options)
    } else {
      api.reload('9148b964', component.options)
    }
    module.hot.accept("./EditarDespacho.vue?vue&type=template&id=9148b964&scoped=true&", function () {
      api.rerender('9148b964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Despacho/EditarDespacho.vue"
export default component.exports